<template>
  <div class="media-uploader">
    <div class="uploader-content fit-content overflow-auto">
      <div class="media-header">
        <div>
          <h1 class="d-flex justify-content-start align-items-center">
            <span>Select date range</span>
          </h1>
        </div>
        <button class="btn-close" @click="close">&times;</button>
      </div>
      <div class="media-container px-4 pb-4 overflow-hidden">
        <button
          class="btn btn-link btn-sm my-2 float-right"
          @click="dateInputChange(false)"
        >
          Clear date
        </button>
        <div class="clearfix"></div>
        <v-date-picker
          class="d-block mx-auto"
          :value="selectedDate"
          mode="date"
          trim-weeks
          is-range
          @input="dateInputChange"
        />
      </div>
      <div class="media-footer">
        <button class="btn btn-outline-secondary btn-sm" @click="close">
          Cancel
        </button>
        <button class="btn btn-info btn-sm" @click="dateSelected">Apply</button>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "media-uploader",
  props: ["dateRange"],
  data() {
    return {
      selectedDate: null,
    };
  },
  methods: {
    dateInputChange(e) {
      this.selectedDate = e;
    },
    dateSelected() {
      if (this.selectedDate === null) {
        Swal.fire("", "Please select start & end date", "warning");
      } else {
        this.$emit("close", this.selectedDate);
      }
    },
    close() {
      this.$emit("close");
    },
  },
  mounted() {
    this.selectedDate = this.dateRange;
  },
};
</script>